import React, { createContext, useContext, useState, ReactNode } from "react";
import { TProductDetail } from "../types";

interface AppContextType {
  products: TProductDetail[];
  setProducts: (products: TProductDetail[]) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [products, setProducts] = useState<TProductDetail[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <AppContext.Provider value={{ products, setProducts, loading, setLoading }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext phải được sử dụng trong AppProvider");
  }
  return context;
};
